var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.066,
    height: 13.066,
    viewBox: "0 0 13.066 13.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(-654.482 -441.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit_24dp_FILL1_wght300_GRAD0_opsz24",
    d: "M140-806.934v-2.6l10.138-10.134a1.3,1.3,0,0,1,.385-.245,1.154,1.154,0,0,1,.442-.086,1.254,1.254,0,0,1,.448.082,1.01,1.01,0,0,1,.384.261l.939.95a.951.951,0,0,1,.255.384,1.307,1.307,0,0,1,.076.435,1.248,1.248,0,0,1-.079.443,1.089,1.089,0,0,1-.252.385L142.6-806.934Zm10.8-9.843,1.113-1.106-.965-.965-1.106,1.113Z",
    transform: "translate(514.482 1261.853)",
    fill: "#015ca3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.05900bbd6e8f36f74e4bd694df226b0a.svg";
export { ForwardRef as ReactComponent };